// extracted by mini-css-extract-plugin
module.exports = {"grid":"BlogPage_grid__2POgi"};